import React from 'react';
import type ScreenSchemesPageType from '@atlassian/jira-admin-pages-screen-schemes-page/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyScreenSchemesPage = lazyForPaint<typeof ScreenSchemesPageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-screen-schemes-page", jiraSpaEntry: "async-jira-admin-pages-screen-schemes-page" */ '@atlassian/jira-admin-pages-screen-schemes-page'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyScreenSchemesPage}
		pageId="jira-admin-pages-screen-schemes-page"
		shouldShowSpinner
	/>
);
